var map = {
	"./gray_circle.png": 1402,
	"./gray_large.png": 1403,
	"./gray_medium.png": 1404,
	"./gray_small.png": 1405,
	"./gray_square.png": 669,
	"./green_large.png": 1406,
	"./green_medium.png": 1407,
	"./green_small.png": 1408,
	"./orange_large.png": 1409,
	"./orange_medium.png": 1410,
	"./orange_small.png": 1411,
	"./yellow_circle.png": 791,
	"./yellow_large.png": 1412,
	"./yellow_medium.png": 1413,
	"./yellow_small.png": 1414,
	"./yellow_trapezium.png": 1415
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1401;